import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './InquiriesManager.css';

function InquiriesManager() {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedInq, setSelectedInq] = useState(null);

  useEffect(() => {
    fetchInquiries();
  }, []);

  const fetchInquiries = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5001/api/forms/inquiries', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInquiries(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching inquiries:', error);
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, status) => {
    const token = localStorage.getItem('token');
    try {
      await axios.patch(
        `http://localhost:5001/api/forms/inquiries/${id}`,
        { status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchInquiries();
      if (selectedInq && selectedInq.id === id) {
        setSelectedInq({ ...selectedInq, status });
      }
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Σφάλμα κατά την ενημέρωση');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το μήνυμα;')) {
      return;
    }

    const token = localStorage.getItem('token');
    try {
      await axios.delete(`http://localhost:5001/api/forms/inquiries/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchInquiries();
      setSelectedInq(null);
    } catch (error) {
      console.error('Error deleting inquiry:', error);
      alert('Σφάλμα κατά τη διαγραφή');
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      new: { className: 'new', label: 'Νέο' },
      read: { className: 'read', label: 'Αναγνώστηκε' },
      replied: { className: 'replied', label: 'Απαντήθηκε' },
      closed: { className: 'closed', label: 'Κλειστό' }
    };
    const badge = badges[status] || badges.new;
    return <span className={`status-badge ${badge.className}`}>{badge.label}</span>;
  };

  const getCategoryLabel = (category) => {
    const labels = {
      general: 'Γενική Πληροφόρηση',
      support: 'Τεχνική Υποστήριξη',
      partnership: 'Συνεργασία',
      billing: 'Οικονομικά',
      other: 'Άλλο'
    };
    return labels[category] || category;
  };

  if (loading) {
    return <div className="loading">Φόρτωση μηνυμάτων...</div>;
  }

  return (
    <div className="inquiries-manager">
      <div className="manager-header">
        <h2>Μηνύματα Επικοινωνίας</h2>
        <span className="count-badge">{inquiries.length} μηνύματα</span>
      </div>

      {inquiries.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📧</div>
          <p>Δεν υπάρχουν μηνύματα ακόμα</p>
        </div>
      ) : (
        <div className="inquiries-container">
          <div className="inquiries-list">
            {inquiries.map(inq => (
              <div 
                key={inq.id} 
                className={`inquiry-card ${selectedInq?.id === inq.id ? 'selected' : ''} ${inq.status === 'new' ? 'unread' : ''}`}
                onClick={() => setSelectedInq(inq)}
              >
                <div className="inq-header">
                  <h3>{inq.name}</h3>
                  {getStatusBadge(inq.status)}
                </div>
                <div className="inq-info">
                  <p className="inq-email">✉️ {inq.email}</p>
                  <p className="inq-category">🏷️ {getCategoryLabel(inq.category)}</p>
                </div>
                <p className="inq-subject"><strong>Θέμα:</strong> {inq.subject}</p>
                <p className="inq-preview">{inq.message.substring(0, 100)}...</p>
                <p className="inq-date">
                  📅 {new Date(inq.submittedAt).toLocaleDateString('el-GR')} {new Date(inq.submittedAt).toLocaleTimeString('el-GR')}
                </p>
              </div>
            ))}
          </div>

          {selectedInq && (
            <div className="inquiry-details">
              <div className="details-header">
                <div>
                  <h2>{selectedInq.name}</h2>
                  <p className="header-email">{selectedInq.email}</p>
                </div>
                <button 
                  className="btn-close"
                  onClick={() => setSelectedInq(null)}
                >
                  ✕
                </button>
              </div>

              <div className="details-content">
                <div className="detail-section">
                  <div className="info-grid">
                    <div>
                      <p><strong>Κατηγορία:</strong> {getCategoryLabel(selectedInq.category)}</p>
                      <p><strong>Email:</strong> <a href={`mailto:${selectedInq.email}`}>{selectedInq.email}</a></p>
                    </div>
                    <div>
                      {selectedInq.phone && <p><strong>Τηλέφωνο:</strong> {selectedInq.phone}</p>}
                      <p><strong>Ημερομηνία:</strong> {new Date(selectedInq.submittedAt).toLocaleString('el-GR')}</p>
                    </div>
                  </div>
                </div>

                <div className="detail-section">
                  <h3>Θέμα</h3>
                  <p className="subject-text">{selectedInq.subject}</p>
                </div>

                <div className="detail-section">
                  <h3>Μήνυμα</h3>
                  <div className="message-text">{selectedInq.message}</div>
                </div>

                <div className="detail-section">
                  <h3>Ενέργειες</h3>
                  <div className="action-buttons">
                    <button 
                      className="btn btn-info"
                      onClick={() => handleStatusChange(selectedInq.id, 'read')}
                      disabled={selectedInq.status === 'read'}
                    >
                      👁️ Αναγνώστηκε
                    </button>
                    <button 
                      className="btn btn-success"
                      onClick={() => handleStatusChange(selectedInq.id, 'replied')}
                      disabled={selectedInq.status === 'replied'}
                    >
                      ✉️ Απαντήθηκε
                    </button>
                    <button 
                      className="btn btn-secondary"
                      onClick={() => handleStatusChange(selectedInq.id, 'closed')}
                      disabled={selectedInq.status === 'closed'}
                    >
                      ✅ Κλείσιμο
                    </button>
                    <button 
                      className="btn btn-outline"
                      onClick={() => handleDelete(selectedInq.id)}
                    >
                      🗑️ Διαγραφή
                    </button>
                  </div>
                  <div className="quick-actions">
                    <a 
                      href={`mailto:${selectedInq.email}?subject=Re: ${selectedInq.subject}`}
                      className="btn btn-primary"
                    >
                      📧 Απάντηση με Email
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default InquiriesManager;
